
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Route } from "vue-router";
    import { Watch } from "vue-property-decorator";
    import * as toastr from "toastr";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import LookupItemDialogue from "@/vue/components/LookupItemDialogue.vue";
    import ApiClient from "@/utilities/ApiClient";
    import Utils from "@/utilities/Utils";
    import { ILookupItem, LookupItem } from "@/model/LookupItem";
    import { LookupGroup } from "@/model/Enums";

    @Component({
        components: { ApiButton, LookupItemDialogue }
    })
    export default class Lookups extends Vue {

        mounted(): void {
            this.onGroupChanged(this.$router.currentRoute.params.group);
        }

        lookupItemHeaders = [
            { text: "Description", value: "description" },
            { text: "Is Archived?", value: "isArchived" }
        ]

        group: LookupGroup = LookupGroup.All;
        resultCount: string = "-";
        lookupItemList: Array<ILookupItem> = [];
        readonly lookupItem = new LookupItem();

        get pageTitle(): string {
            const desc = LookupGroup[this.group];
            return desc ? Utils.camelCaseAddSpaces(desc) : "Lookups - " + this.group;
        }

        get dialogueTitle(): string {
            if (!this.lookupItem) return "- - -";
            if (Utils.isEmptyId(this.lookupItem.id)) return "New Item";
            return "Edit " + this.lookupItem.description;
        }

        //
        // -- watchers
        //

        // if the group ID changes in the URL, the component *will not* reload - so we need to handle it here
        @Watch("$route", { immediate: true, deep: true })
        onRouteChanged(route: Route): void {
            this.onGroupChanged(route.params.group);
        }

        //
        // -- methods
        //

        onGroupChanged(groupText: string): void {
            const typedGroupString = groupText as keyof typeof LookupGroup;
            const group = LookupGroup[typedGroupString];
            if (this.group === group) return;
            this.group = group;
            this.search();
        }

        editNew(): void {
            const dialogue: LookupItemDialogue = this.$refs.lookupItemDialogue as LookupItemDialogue;
            dialogue.add(this.group);
        }

        edit(lookupItemData: ILookupItem): void {
            const dialogue: LookupItemDialogue = this.$refs.lookupItemDialogue as LookupItemDialogue;
            dialogue.edit(lookupItemData);
        }

        async search(): Promise<void> {
            this.resultCount = "-";
            if (this.group < 1) {
                toastr.error("Missing group ID!");
                return;
            }
            // if we want the list to be instances of LookupItem class, we'd need to map here
            this.lookupItemList = await ApiClient.get(`/api/lookup/search/${this.group}?isArchived=`, "lookup-search");
            this.resultCount = String(this.lookupItemList.length);
        }
    }
